import React from 'react';
import { Breadcrumbs, Box, Typography } from '@mui/material';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useRouter } from 'next/router';
import { shape } from 'prop-types';

import BreadcrumbLink from '../BreadcrumbLink';
import themes from '../../theme/helpers/blockThemes';

const Breadcrumb = ({ theme, stateData, cityData, neighborhoodData }) => {
  const { asPath } = useRouter();
  const pathArr = asPath.split('/');
  const breadcrumbTheme = themes[theme];

  const crumbs = () => {
    let crumbLinks = {};
    if (neighborhoodData) {
      crumbLinks = [
        <BreadcrumbLink link={pathArr[0]} location="Home" />,
        <BreadcrumbLink link={`${pathArr[1]}/${pathArr[4]}`} location={`${neighborhoodData.cityV2.state.state}`} />,
        <BreadcrumbLink link={`${pathArr[1]}/${pathArr[2]}/${pathArr[4]}`} location={`${neighborhoodData.cityV2.city}`} />,
        <Typography color="text.primary" variant="body2">
          {neighborhoodData.neighborhoodGenPages[0].serviceName}
        </Typography>,
      ];
    }

    if (cityData) {
      crumbLinks = [
        <BreadcrumbLink link={pathArr[0]} location="Home" />,
        <BreadcrumbLink link={`${pathArr[1]}/${pathArr[3]}`} location={`${cityData.state.state}`} />,
        <Typography color="text.primary" variant="body2">
          {cityData.cityGenPagesV2[0].serviceName}
        </Typography>,
      ];
    }

    if (stateData) {
      crumbLinks = [
        <BreadcrumbLink link={pathArr[0]} location="Home" />,
        <Typography color="text.primary" variant="body2">
          {stateData.stateGenPages[0].serviceName}
        </Typography>,
      ];
    }

    if (stateData || cityData || neighborhoodData) {
      return (
        <Box py={1} mx="auto" bgcolor={breadcrumbTheme?.backgroundColor}>
          <Box
            px={{
              xs: 3,
              sm: 12,
              md: 10,
              lg: 15,
              xl: 27,
            }}
            display="flex"
            justifyContent="start"
          >
            <Breadcrumbs separator={<DoubleArrowIcon fontSize="small" />} aria-label="breadcrumb">
              {crumbLinks}
            </Breadcrumbs>
          </Box>
        </Box>
      );
    }

    return null;
  };

  return crumbs();
};

Breadcrumb.propTypes = {
  stateData: shape({}),
  cityData: shape({}).isRequired,
  neighborhoodData: shape({}),
};

export default Breadcrumb;
